export default {
  general: {
    canInteractSoldProperties: false,
    canInteractOnHoldProperties: false,
    showSoldNeighbourhoods: false,
    showSoldSlides: false,
  },

  filter: {
    enabled: false,
  },

  rightSidebar: {
    propertyGuide: {
      active: true,
      items: ["Withheld", "Available", "On Hold", "Sold"],
    },
  },
};
